module.exports = __webpack_public_path__ + "static/media/ai-fundamentals-practitioner-badge.1.2d435b18.png";